import * as React from 'react';
import * as i18n from 'i18next';
import { Button } from 'components';
import { PortalPageSection, ButtonsSection } from 'components/PortalStructure';
import { Link } from 'react-router';

interface IProps {
	shopId: string;
	officeId?: string;
	memberId?: string;
	hideButton?: boolean;
}

const NoBookingTemplates: React.FC<IProps> = (props: IProps) => {
	return (
		<div className="container">
			<br />
			<PortalPageSection variant="dark">
				<div>
					{i18n.t(
						props.memberId
							? 'Shop_WorkTime_EditHours_NoMemberBookingTemplates'
							: 'Shop_WorkTime_EditHours_NoBookingTemplates',
					)}
				</div>
				{!props.hideButton && props.shopId && props.officeId ? (
					<ButtonsSection>
						<Link to={`/shop/${props.shopId}/${props.officeId}/edit/services`}>
							<Button>{i18n.t('User_ShopCard_Services_EditServices')}</Button>
						</Link>
					</ButtonsSection>
				) : null}
			</PortalPageSection>
			<br />
		</div>
	);
};

const NoStaffMembers: React.FC<IProps> = (props: IProps) => {
	return (
		<div className="container">
			<br />
			<PortalPageSection variant="dark">
				<div>{i18n.t('Shop_Appointments_Filter_Staff_Empty')}</div>
				{props.shopId && !props.hideButton ? (
					<ButtonsSection>
						<Link to={`/shop/${props.shopId}/edit/members`}>
							<Button>{i18n.t('Shop_ManageShop_Members_Label_AddStaff')}</Button>
						</Link>
					</ButtonsSection>
				) : null}
			</PortalPageSection>
			<br />
		</div>
	);
};

const NoOfficeTimes: React.FC<IProps> = (props: IProps) => {
	return (
		<div className="container">
			<br />
			<PortalPageSection variant="dark">
				<div>{i18n.t('Shop_WorkTime_EditHours_NoOfficeTimes')}</div>
				{!props.hideButton && props.shopId ? (
					<ButtonsSection>
						<Link to={`/shop/${props.shopId}/edit/locations`}>
							<Button>{i18n.t('User_ShopCard_Title_OpeningHours')}</Button>
						</Link>
					</ButtonsSection>
				) : null}
			</PortalPageSection>
			<br />
		</div>
	);
};

export { NoBookingTemplates, NoStaffMembers, NoOfficeTimes };
